<div class="locations-setup">
  <!-- ======================================================
       Heading
  ======================================================= -->

  <div class="locations-heading">
    <div>
      <span class="locations-kicker"> Step 1 </span>

      <h3>Match your locations</h3>

      <p>
        Link Square locations with existing gloget salons, create missing salons
        in gloget, or create missing Square locations from your existing gloget
        salons.
      </p>
    </div>
  </div>

  <!-- ======================================================
       Messages
  ======================================================= -->

  <div *ngIf="successMessage" class="location-notice location-notice--success">
    {{ successMessage }}
  </div>

  <div *ngIf="errorMessage" class="location-notice location-notice--error">
    {{ errorMessage }}
  </div>

  <!-- ======================================================
       Square locations
  ======================================================= -->

  <section class="location-section">
    <div class="location-section__header">
      <div>
        <h4>Square locations</h4>

        <p>Connect each Square location to gloget.</p>
      </div>

      <span class="count-pill">
        {{ squareLocations.length }}
      </span>
    </div>

    <div *ngIf="squareLocations.length === 0" class="empty-state">
      No Square locations were found.
    </div>

    <div class="location-list">
      <article
        *ngFor="let location of squareLocations"
        class="location-card"
        [class.location-card--mapped]="!!location.mapping"
      >
        <div class="location-card__main">
          <div class="source-badge source-badge--square">Square</div>

          <div class="location-card__identity">
            <div class="location-title-row">
              <h5>
                {{ location.name }}
              </h5>

              <span *ngIf="location.mapping" class="mapped-pill">
                ✓ Mapped
              </span>
            </div>

            <p *ngIf="formatSquareAddress(location)">
              {{ formatSquareAddress(location) }}
            </p>

            <small *ngIf="location.phone_number">
              {{ location.phone_number }}
            </small>
          </div>
        </div>

        <!-- Existing mapping -->

        <div *ngIf="location.mapping" class="mapped-result">
          <span> Connected to </span>

          <strong>
            {{ location.mapping.salon_name }}
          </strong>
        </div>

        <!-- Not mapped -->

        <div *ngIf="!location.mapping" class="location-actions">
          <div class="map-existing">
            <label> Map to existing gloget salon </label>

            <div class="map-existing__controls">
              <select [(ngModel)]="selectedSalonBySquareLocation[location.id]">
                <option value="">Select salon</option>

                <option
                  *ngFor="let salon of availableSalonsFor(location)"
                  [value]="salon.id"
                >
                  {{ salon.name }}
                </option>
              </select>

              <button
                type="button"
                class="map-button"
                [disabled]="mappingLocationId === location.id"
                (click)="mapExisting(location)"
              >
                {{ mappingLocationId === location.id ? "Mapping..." : "Map" }}
              </button>
            </div>
          </div>

          <div class="action-divider">
            <span> or </span>
          </div>

          <button
            type="button"
            class="create-button"
            (click)="openCreateInGloget(location)"
          >
            Create new salon in gloget
          </button>
        </div>
      </article>
    </div>
  </section>

  <!-- ======================================================
       gloget-only salons
  ======================================================= -->

  <section class="location-section">
    <div class="location-section__header">
      <div>
        <h4>gloget-only salons</h4>

        <p>
          These salons do not currently have a Square location mapped to them.
        </p>
      </div>

      <span class="count-pill">
        {{ unmappedGlogetSalons.length }}
      </span>
    </div>

    <div
      *ngIf="unmappedGlogetSalons.length === 0"
      class="empty-state empty-state--success"
    >
      ✓ All gloget salons are connected to Square.
    </div>

    <div class="location-list">
      <article *ngFor="let salon of unmappedGlogetSalons" class="location-card">
        <div class="location-card__main">
          <div class="source-badge source-badge--gloget">gloget</div>

          <div class="location-card__identity">
            <h5>
              {{ salon.name }}
            </h5>

            <p *ngIf="formatGlogetAddress(salon)">
              {{ formatGlogetAddress(salon) }}
            </p>

            <small *ngIf="salon.phone">
              {{ salon.phone }}
            </small>
          </div>
        </div>

        <div class="gloget-only-actions">
          <span> No Square location mapped </span>

          <button
            type="button"
            class="create-square-button"
            [disabled]="creatingSquareSalonId === salon.id"
            (click)="createInSquare(salon)"
          >
            {{
              creatingSquareSalonId === salon.id
                ? "Creating..."
                : "Create in Square"
            }}
          </button>
        </div>
      </article>
    </div>
  </section>

  <!-- ======================================================
       Create gloget salon modal
  ======================================================= -->

  <div
    *ngIf="showCreateGlogetModal"
    class="modal-backdrop"
    (click)="closeCreateGlogetModal()"
  >
    <div
      class="create-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="create-gloget-salon-title"
      (click)="$event.stopPropagation()"
    >
      <div class="create-modal__header">
        <div>
          <span class="modal-kicker"> Square → gloget </span>

          <h3
            id="
              create-gloget-salon-title
            "
          >
            Create salon in gloget
          </h3>

          <p>
            Review the information imported from Square and complete any missing
            fields.
          </p>
        </div>

        <button
          type="button"
          class="modal-close"
          [disabled]="createGlogetSubmitting"
          aria-label="Close"
          (click)="closeCreateGlogetModal()"
        >
          ×
        </button>
      </div>

      <!-- Source -->

      <div *ngIf="selectedSquareLocation" class="modal-source">
        <span> Square location </span>

        <strong>
          {{ selectedSquareLocation.name }}
        </strong>

        <small *ngIf="formatSquareAddress(selectedSquareLocation)">
          {{ formatSquareAddress(selectedSquareLocation) }}
        </small>
      </div>

      <!-- Error -->

      <div
        *ngIf="createGlogetError"
        class="location-notice location-notice--error"
      >
        {{ createGlogetError }}
      </div>

      <!-- Form -->

      <div class="modal-form">
        <div class="form-field">
          <label for="gloget-salon-name">
            Salon name
            <span>*</span>
          </label>

          <input
            id="gloget-salon-name"
            type="text"
            [(ngModel)]="createGlogetForm.name"
            [disabled]="createGlogetSubmitting"
          />
        </div>

        <div class="modal-form__grid">
          <div class="form-field">
            <label for="gloget-salon-email">
              Email
              <span>*</span>
            </label>

            <input
              id="gloget-salon-email"
              type="email"
              [(ngModel)]="createGlogetForm.email"
              [disabled]="createGlogetSubmitting"
              placeholder="salon@example.com"
            />
          </div>

          <div class="form-field">
            <label for="gloget-salon-phone">
              Phone
              <span>*</span>
            </label>

            <input
              id="gloget-salon-phone"
              type="tel"
              [(ngModel)]="createGlogetForm.phone"
              [disabled]="createGlogetSubmitting"
              placeholder="+1 416..."
            />
          </div>
        </div>

        <div class="form-divider">Imported address</div>

        <div class="form-field">
          <label> Street address </label>

          <input type="text" [(ngModel)]="createGlogetForm.address" disabled />
        </div>

        <div class="modal-form__grid modal-form__grid--address">
          <div class="form-field">
            <label> City </label>

            <input type="text" [(ngModel)]="createGlogetForm.city" disabled />
          </div>

          <div class="form-field">
            <label> Province / State </label>

            <input type="text" [(ngModel)]="createGlogetForm.state" disabled />
          </div>

          <div class="form-field">
            <label> Postal code </label>

            <input
              type="text"
              [(ngModel)]="createGlogetForm.postal_code"
              disabled
            />
          </div>

          <div class="form-field">
            <label> Country </label>

            <input
              type="text"
              [(ngModel)]="createGlogetForm.country"
              disabled
            />
          </div>
        </div>

        <p class="import-note">
          Address information is being copied directly from Square. You can edit
          the salon later from Store Settings.
        </p>
      </div>

      <!-- Footer -->

      <div class="create-modal__footer">
        <button
          type="button"
          class="modal-cancel-button"
          [disabled]="createGlogetSubmitting"
          (click)="closeCreateGlogetModal()"
        >
          Cancel
        </button>

        <button
          type="button"
          class="modal-submit-button"
          [disabled]="createGlogetSubmitting"
          (click)="submitCreateInGloget()"
        >
          <span *ngIf="createGlogetSubmitting" class="modal-spinner"></span>

          {{ createGlogetSubmitting ? "Creating..." : "Create & map salon" }}
        </button>
      </div>
    </div>
  </div>
</div>
